import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';
import {NavLink} from 'react-router-dom'
import {Container, Col, Row} from 'reactstrap'
import Loading from 'apa/components/Loading';
import {formatDate} from 'invoices/containers/InvoiceDetail';

@connect(
    state => ({
        user: state.apa.user,
        errors: state.apa.errors,
        isAuthenticated: state.apa.isAuthenticated,
        isLoading: state.apa.isLoading
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Home extends Component {

    state = {
        code: '',
        username: '',
        password: '',
        repeatPassword: '',
        captcha: '',
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const {
            username,
            password
        } = this.state;
        this.props.login(username, password)
    }


    render() {
        const year = new Date().getFullYear();
        const {user} = this.props

        if(this.props.user.is_superuser) {
            return (
              <Container><h1>Willkommen {this.props.user.username}</h1></Container>
            );
        }

        const start = (new Date(user.access_code.training.start_at)).toLocaleDateString('de')
        const end = (new Date(user.access_code.training.end_at)).toLocaleDateString('de')
        const name = user.access_code.training.name

        if(this.props.isLoading)
            return <Loading/>;
        return (
            <Container>
                <h1>
                    Willkommen zur diesjährigen {year} Sicherheits-Unterweisung / Schulung
                </h1>
                <p>
                    {name}
                </p>
                <h2>
                    Einleitung
                </h2>
                <p>
                    Die für Sie bereitstehenden Unterweisungs- Präsentationen steht in dem vorgegebenen Zeitraum {start} - {end} jederzeit für Sie bereit. Nach Ablauf des genannten Datums wird der Zugang automatisch gesperrt.
                </p>
                <p className='alert alert-danger'>
                    Sollten Gründe wie z.B. Urlaubsaufenthalt, Krankheit etc. vorliegen, ist ein neues Zeitfenster für den betroffenen Teilnehmer durch den Verantwortlichen zu bestimmen.
                </p>
                <p>
                   Andernfalls ist ein Termin zur persönlichen Unterweisung zu finden. 
                </p>
                <h2>
                    Präsentation START
                </h2>
                <p>
                    Nach Starten der Präsentation können Sie jederzeit unterbrechen. Bei erneuter Anmeldung starten Sie bei der zuletzt von Ihnen gesehenen Präsentationsseite.
                </p>
                <p>
                    Sie können jederzeit und so oft sie wollen, in der Präsentation vor- bzw. zurückgehen. Nehmen Sie sich Zeit! Niemand drängelt!
                </p>
                <h2>
                    Präsentation ENDE
                </h2>
                <p>
                    Am Ende der Präsentation haben Sie folgende Möglichkeiten:
                </p>
                <ol>
                    <li>
                        Zurück zum Start - <span className='text-danger'>Präsentation startet erneut</span>
                    </li>
                    <li>
                        Weiter zur Wissenskontrolle - <span className='text-danger'>Es öffnet sich ein Fragenkatalog zur Wissenskontrolle.</span>
                    </li>
                </ol>
                <ul>
                    <li>
                        Nach dem Start der Wissenskontrolle ist diese bis zum Ende durchzuführen.
                    </li>
                    <li>
                        Jeder Neustart der Wissenskontrolle erstellt einen neuen Fragenkatalog.
                    </li>
                </ul>
                <h2>
                    Wissenskontrolle
                </h2>
                <p>
                    Am Ende der Wissenskontrolle gibt es folgende Möglichkeiten:
                </p>
                <ol>
                    <li>
                        Super, Glückwunsch, Sie haben die notwendige Punktzahl erreicht! – (mind. 65 von 100% erreicht)
                        <p className='text-danger'>
                            (für Teilnehmerzertifikat bitte hier drücken)
                        </p>
                    </li>
                    <li>
                        Schade, da fehlten nur ein paar Punkte! –3 zusätzliche Fragen stehen für Sie bereit (50 bis 65% erreicht)
                        <p className='text-danger'>
                            (für 2ten und/oder 3ten Versuch bitte hier drücken)
                        </p>
                    </li>
                    <li>
                        Upps, die zu erreichende Punktzahl ist nicht erreicht! – (0 bis 50% erreicht)
                        <p className='text-danger'>
                            (für neuer Fragebogen hier drücken)
                            <br/>
                            (zum Start der Präsentation bitte hier drücken)
                        </p>
                    </li>
                </ol>
                <p>
                    Nach erreichter Punktzahl und damit erfolgreichem Abschluss der Wissenskontrolle wird Ihr Zugang gesperrt.
                </p>
                <h2>
                    Fragen oder Kommentare
                </h2>
                <p>
                    Sie haben Fragen, ein Anliegen, Anregungen, Verbesserungsvorschläge, Bedürfnisse etc.? 
                </p>
                <p>
                    Schicken Sie eine E-Mail an unsere Sicherheitsfachkraft und/oder wenden Sie sich auch gerne an Ihren direkten Vorgesetzten. Wir freuen uns auf ein gemeinsames, unfallfreies und gesundes Jahr!
                </p>
                <p className='text-center'>
                    <a href="mailto:info@sicher-arbeiten.hamburg">info@sicher-arbeiten.hamburg</a>
                </p>
                <p>
                    Die von Ihnen gesendete Mail wird nicht ohne Ihr ausdrückliches (schriftliches) Einverständnis weitergegeben.
                </p>
                <p className='text-bold'>
                    Nach Starten der Präsentation können Sie jederzeit unterbrechen und starten nach erneuter Anmeldung bei der zuletzt von Ihnen gesehenen Präsentationsseite
                </p>
                <p className='text-center'>
                    <NavLink className='btn btn-primary' to={'/training/do'}>Weiter zur Präsentation</NavLink>
                </p>
            </Container>
        )
    }
}

Home.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
